import { useSelector } from "react-redux";

import { TerrainCanvasInfo, TwoDWaterflow } from "@nens/deck-gl";

import { getTwoDFlowSpeedLayer } from "../../../state/layerCalculationMenu";
import { getGridcells, getTwoDeeData } from "../../../state/simulation";

const TwoDFlow: React.FC<{ terrainCanvasInfo?: TerrainCanvasInfo | null }> = ({
  terrainCanvasInfo,
}) => {
  const twoDFlowData = useSelector(getTwoDeeData);
  const gridCells = useSelector(getGridcells);
  const twoDFlowLayerConfig = useSelector(getTwoDFlowSpeedLayer);

  if (!twoDFlowData || twoDFlowLayerConfig.disabled) return null;

  return (
    <TwoDWaterflow
      features={gridCells.features}
      twoDFlowData={twoDFlowData}
      config={twoDFlowLayerConfig}
      terrainCanvasInfo={terrainCanvasInfo}
    ></TwoDWaterflow>
  );
};

export default TwoDFlow;
